
import React from 'react';
import { MessageSquare, Plus, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyChatsStateProps {
  icon?: 'message' | 'star';
  title: string;
  description: string;
  showButton?: boolean;
  onNewChat?: () => void;
}

const EmptyChatsState = ({ 
  icon = 'message', 
  title, 
  description, 
  showButton = false,
  onNewChat
}: EmptyChatsStateProps) => {
  return (
    <div className="text-center py-12 border rounded-lg bg-muted/20">
      {icon === 'message' ? (
        <MessageSquare className="h-12 w-12 mx-auto text-muted-foreground" />
      ) : (
        <Star className="h-12 w-12 mx-auto text-muted-foreground" />
      )}
      <h3 className="mt-4 text-lg font-medium">{title}</h3>
      <p className="mt-2 text-muted-foreground">
        {description}
      </p>
      {showButton && onNewChat && (
        <Button 
          onClick={onNewChat} 
          className="mt-4 gap-2"
          type="button"
        >
          <Plus size={16} />
          New Chat
        </Button>
      )}
    </div>
  );
};

export default EmptyChatsState;
